import React from 'react'
import { Role } from '../../../../models/role'

type Props = {
	title: string
	tabKey: string
	allowedRoles?: Role[]
	notAllowedRoles?: Role[]
	isAllowed?: boolean
	showWarning?: boolean
	showNotice?: boolean
}

const Tab: React.FC<Props> = ({ children }) => {
	return <div>{children}</div>
}

export default Tab
